import { Button, Card, InputNumber, Modal, notification, Select } from "antd"
import Form from "antd/es/form/Form"
import Input from "antd/es/input/Input"
import Title from "antd/es/typography/Title"
import { CreateRoom, GetAllRoomTypes } from "../../../api/AdminService"
import { useNavigate } from "react-router-dom"
import { Option } from "antd/es/mentions"
import { useEffect, useState } from "react"
import { ArrowLeftOutlined } from "@ant-design/icons"
const AddminAddRoom = ({ open, onClose, onSuccess }) => {
    const [roomType, setRoomType] = useState([]);
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);

    const GetRoomType = () => {
        GetAllRoomTypes().then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setRoomType(res.data)
            }
        })
    }

    useEffect(() => {
        GetRoomType();
    }, [])

    const onFinish = (values) => {
        setLoading(true);
        CreateRoom(values.roomTypeId, values.name, values.capacity).then(res => {
            if (res.status === 201) {
                console.log(res)
                notification.success({
                    message: "Created Room Successfully"
                })
                setLoading(false);
                onSuccess();
                onClose();

            }
        }).catch(err => {
            console.log(err.response)
            notification.error({
                message: `${err.response.data.message}`
            });
            setLoading(false)
        })
    }


    return (
        // <div style={{ minHeight: '96.5vh', Width: '100%' }}>
        //     <Button
        //         icon={<ArrowLeftOutlined />}
        //         onClick={() => navigate(-1)}
        //         style={{ marginBottom: 16 }}
        //     >
        //         Go Back
        //     </Button>
        //     <div style={{ maxWidth: 600, margin: 'auto', padding: '24' }}>
        //         <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
        //             Create Room
        //         </Title>
        <Modal
            open={open}
            title="Create Room"
            onCancel={onClose}
            footer={[]}
        >
            <Form
                onFinish={onFinish}
                name="wrap"
                labelAlign="left"
                labelWrap
                labelCol={{ flex: '150px' }}
            >
                
                    <Form.Item name={"name"} label="Room Name" rules={[{ required: true, message: 'Requiring Room Name' }]}>
                        <Input
                            placeholder="Input Room Name"
                        />
                    </Form.Item>
                    <Form.Item name={"capacity"} label="Capacity" rules={[{ required: true, message: 'Requiring capacity' }]}>
                        <InputNumber style={{ width: '100%' }} min={1}
                            placeholder="Input Capacity"
                        />
                    </Form.Item>
                    <Form.Item name={"roomTypeId"} label="Choose Room Type"
                        rules={[
                            {
                                required: true,
                                message: 'Requiring type',
                            },
                        ]}
                    >
                        <Select
                            placeholder="Choose Room Type"
                        >
                            {roomType.map((item) => (
                                <Option key={item.id} value={item.id}>
                                    {item.name}
                                </Option>
                            ))}

                        </Select>
                    </Form.Item>

                    <Form.Item >
                        <Button block type="primary" htmlType="submit" loading={loading}>
                            {loading ? "Loading" : "Save"}
                        </Button>
                    </Form.Item>
                
            </Form>
        </Modal>
        //     </div>
        // </div>
    )

}
export default AddminAddRoom